import React, { useState, useEffect } from "react";
import useFormValidation from "../../components/auth/useFormValidation";
import validateCreateTema from "../../components/auth/validateCreateTema";
import FirebaseContext from "../../firebase/context";
import { Link, withRouter } from "react-router-dom";
import TableCell from '@material-ui/core/TableCell';
import { Button, TableRow, TextField, Typography, Grid, Container, Paper, Avatar } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import CompUpload from './UploadFoto';
import validateLogin from "./validateLogin";
import punto5Avatar from '../../img/Punto5_Avatar.png'
import EditIcon from '@material-ui/icons/Edit';
import PerfilUsuarioEdit from "./PerfilUsuarioEdit";
import UsuarioContext from "../../privado/contex/UsuarioContext";

const style = {
    paper: {
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    form: {
        width: "100%",
        marginTop: 20
    },
    submit: {
        marginTop: 15,
        marginBottom: 20
    },
    avatar: {
        margin: 10,
        width: 100,
        height: 100

    }
};

const PerfilUsuario = (props) => {

    const { firebase, user } = React.useContext(FirebaseContext);
    const [userDB, setUserDB] = useState([{}])
    const [fotoURL, setFotoURL] = useState("")
    const [enableEdit, setEnableEdit] = useState(false)
    const [updateUser, setUpdateUser] = useState(false)

         ////////////////////////////////////////////////////////////////////  
         const usuarioContextLocal = React.useContext(UsuarioContext);
         const { setObjUsuario } = usuarioContextLocal;
         
         React.useEffect(() => {
             firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
                 const arrayUsuario = snapshot.docs.map(doc => {
                     let data = doc.data();
                     let id = doc.id;
                     return { id, ...data };
                 });            
                 setObjUsuario(arrayUsuario[0]);   
             });
         }, [])
     ///////////////////////////////////////////////////////////////////////////

    React.useEffect(() => {
        getUsuario();
    }, [updateUser]);

    const getUsuario = async () => {
        try {
            const usuarioDB = await firebase.db.collection("colUsuarios").where("id", "==", userId).get()
            const arraryUsuario = usuarioDB.docs.map(doc => ({ id: doc.id, ...doc.data() }))         
            setUserDB(arraryUsuario[0])   
            setUpdateUser(false)        
        } catch (error) {
            console.log(error);
        }
    }

    let userId = user.uid

    return (
        <Container style={style.cardGrid}>
            <Paper style={style.paper}>
                <Avatar style={style.avatar} src={userDB.fotoUrl || punto5Avatar} />
                <Typography component="h1" variant="h5">
                    Perfil de Cuenta
                </Typography>

                <Grid container spacing={2}>

                <Grid item xs={12} md={6}>
                <Typography component="h1" variant="h5">
                Nombre: {userDB.nombre}
                </Typography>
                </Grid>

                 <Grid item xs={12} md={6}>
                <Typography component="h1" variant="h5">
                Apellido: {userDB.apellido}
                </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                <Typography component="h1" variant="h5">
                Email: {userDB.email}
                </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                <Typography component="h1" variant="h5">
                Telefono: {userDB.telefono}
                </Typography>
                </Grid>
                {
                    enableEdit ? (
                        <PerfilUsuarioEdit
                        userDB = {userDB}
                        setEnableEdit = {setEnableEdit}
                        setUpdateUser = {setUpdateUser}
                        setFotoURL = {setFotoURL}
                        />
                    ) : null
                }
          

                <Grid item xs={12} md={6}>
                <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="button"
                            startIcon={<EditIcon />}
                            onClick = {() => setEnableEdit(true)}
                        >
                            Editar
                        </Button>
                </Grid>
        
                </Grid>
            </Paper>
        </Container>

    );
}

export default PerfilUsuario
